import React, { useEffect, useState } from "react";
import { sanityApi } from "@/features/sanity";
import "swiper/css";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";

const CategoryCarousel = () => {
  const [categories, setCategories] = useState([]);
  useEffect(() => {
    async function loadCategories() {
      const data = await sanityApi.fetchCategoriesWithPosts();
      setCategories(data);
    }
    loadCategories();
  }, []);

  return (
    <section className="py-12 sm:py-16 lg:py-20">
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <h2 className="text-2xl md:text-3xl font-semibold font-serif text-prime-950 py-2 sm:text-xl xl:text-3xl">
          Tipps und aktuelles rund um Ihre Immobilie
        </h2>
        <p className="text-gray-600 ">
          Ob Kauf, Verkauf oder Vermietung – hier finden Sie Antworten,
          Orientierung und wertvolle Einblicke.
        </p>

        {/* Mobile Carousel */}
        <ScrollArea className=" whitespace-nowrap">
          <div className="flex gap-5 p-5 pt-16">
            {categories.map((category, index) => (
              <div
                key={index}
                className="w-[19rem] text-wrap bg-gray-50 rounded-lg shadow-md overflow-hidden"
              >
                <img
                  className="w-full h-40 object-cover"
                  src={category.imageUrl || "/placeholder.jpg"}
                  alt={category.name}
                />
                <div className="p-5">
                  <h3 className="font-sans text-prime-950 text-xl font-medium">
                    {category.name}
                  </h3>
                  <ul className="mt-5 mb-7 font-sans space-y-3">
                    {category.posts.map((post, i) => (
                      <li key={i}>
                        <a
                          href={`/ratgeber/${post.slug.current}`}
                          className="text-blue-500 hover:underline hover:underline-offset-2 transition-all hover:decoration-2"
                        >
                          {post.title}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
          <ScrollBar orientation="horizontal" className="fill-blue-500" />
        </ScrollArea>
      </div>
    </section>
  );
};

export default CategoryCarousel;
